import { render, staticRenderFns } from "./TextEditorIntro.vue?vue&type=template&id=19c4d13e&scoped=true"
import script from "./TextEditorIntro.vue?vue&type=script&lang=js"
export * from "./TextEditorIntro.vue?vue&type=script&lang=js"
import style0 from "./TextEditorIntro.vue?vue&type=style&index=0&id=19c4d13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4d13e",
  null
  
)

export default component.exports